import { Component, OnInit } from '@angular/core';
import { DialogRef } from 'angular2-modal';

import { AuthService } from '../../../../../../../../providers/auth.service';
import { SharedHackService } from '../../../../../../shared/services/shared-hack.service';

import { default as swal } from 'sweetalert2';


export class ViewProjectChallengeModalComponent implements OnInit {
	public challenge: any;
	public state: any;

	constructor(
		public dialog: DialogRef<any>,
		private authService: AuthService,
		private sharedHackService: SharedHackService) { }

	// LifeCycle EventListener
	public ngOnInit(): void {
		if (this.checkInitData()) {
			this.getChallenge();
		}
	}

	// Events
	public closeModal(): void {
		this.dialog.close();
	}

	// Service call
	private getChallenge(): void {
		if (this.state.fromLibrary) {
			this.sharedHackService.getProjectChallengeLibrary(String(this.authService.userId), this.state.challengeId).subscribe(
				(challenge) => {
					this.challenge = challenge;
				}
			);
		} else {
			this.sharedHackService.getProjectChallenge(String(this.authService.userId), this.state.challengeId).subscribe(
				(challenge) => {
					this.challenge = challenge;
				}
			);
		}
	}

	private checkInitData(): boolean {
		let pass: boolean = true;
		if (!this.dialog.context.initData) {
			pass = false;
		}
		if (!this.dialog.context.initData.challengeId) {
			pass = false;
		}
		if (!pass) {
			this.closeModal();
			this.handleError({message: 'The mandatory data is missing!'});
		} else {
			this.state = this.dialog.context.initData;
		}
		return pass;
	}

	private handleError(error: any) {
		console.log(error);
		let errMsg = (error.message) ? error.message :
			error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
	}
static ctorParameters() { return [ { type: DialogRef }, { type: AuthService }, { type: SharedHackService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/summary/project/library/view/view.component.ts